import React from "react";
import { Link } from "react-router-dom";

const cardStyle: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid #e5e7eb",
  borderRadius: 16,
  padding: "1rem",
};

const linkButtonStyle: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  textDecoration: "none",
  border: "1px solid #d1d5db",
  borderRadius: 12,
  background: "#ffffff",
  color: "#111827",
  padding: "0.8rem 1rem",
  fontWeight: 700,
};

const sampleStylists = [
  {
    name: "Aman Deep",
    role: "Senior barber",
    experience: "7 years",
    specialties: "Skin fades, beard sculpting",
  },
  {
    name: "Riya Kaur",
    role: "Beauty stylist",
    experience: "5 years",
    specialties: "Bridal makeup, skincare prep",
  },
];

export default function ProviderStylistsPage() {
  return (
    <div style={{ display: "grid", gap: "1rem" }}>
      <section style={cardStyle}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "0.75rem",
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <div>
            <h2 style={{ margin: 0, color: "#0f172a" }}>Stylists</h2>
            <p style={{ margin: "0.45rem 0 0", color: "#475569", lineHeight: 1.7 }}>
              Create provider-side team members here so onboarding review has operational context.
            </p>
          </div>

          <Link to="/provider/dashboard/stylists/new" style={linkButtonStyle}>
            Add stylist
          </Link>
        </div>
      </section>

      {sampleStylists.map((stylist) => (
        <section key={stylist.name} style={cardStyle}>
          <h3 style={{ margin: 0, color: "#0f172a" }}>{stylist.name}</h3>
          <p style={{ margin: "0.4rem 0 0", color: "#334155" }}>{stylist.role}</p>
          <p style={{ margin: "0.4rem 0 0", color: "#64748b" }}>
            {stylist.experience} · {stylist.specialties}
          </p>
        </section>
      ))}

      <section style={cardStyle}>
        <Link to="/provider/onboarding/review" style={linkButtonStyle}>
          Return to onboarding review
        </Link>
      </section>
    </div>
  );
}